import type { FaireProductEntity } from "../../entity_types/product";

export const p_9dhrdqerfs: FaireProductEntity = {
  token: "p_9dhrdqerfs",
  type: "product",
  name: "Campo dei Fiori Travel Scarf/Wrap",
  brandToken: "b_ipe57bk2",
  brandName: "Margolis Pineo Italia",
  imageUrl:
    "https://cdn.faire.com/fastly/f1036f73a45b877ea5467710aa10dc48da0538ea0e182e8b67615a030f57233c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d2532ea72c81c7759dfc0c1c2deaace7516361b36baf1cd0d965fd51a5956f83.jpeg",
    "https://cdn.faire.com/fastly/4f74d912e6f7ecef49e7e44fe813d2c9c74e5ff1d3f93d363e1bba1e80d20f45.jpeg",
    "https://cdn.faire.com/fastly/9da90f1b02ec61fd474e6ea515b31253f3fb68150a1f56ac7235e24d28b60934.jpeg",
    "https://cdn.faire.com/fastly/90b8dfdc2ac9f56d80a9cf41f4f4721c7890dff5cfdf3385b36a79d092ed41b1.jpeg",
    "https://cdn.faire.com/fastly/e9787b10eafe5b3415a6ddfbbb491ef5a0d293475cdff22a92484f0375eb6a75.jpeg",
    "https://cdn.faire.com/fastly/8bca60c3f65ed3625f440a8207f47e9877e10a8f2f3c0162086304c868e322e6.jpeg",
    "https://cdn.faire.com/fastly/35f9348ee603eef21592b9c53bf5bc046327b2e804a3255fadee82ff72191198.jpeg",
    "https://cdn.faire.com/fastly/2d5fb952b05b4e9ca33fd8e2c028c2221812bbd5434a0b22ad499640d456a286.jpeg",
    "https://cdn.faire.com/fastly/473a94325f359676924aea6a1596dab72b3e3ce18762701ce51199b6c943153d.jpeg",
    "https://cdn.faire.com/fastly/3c6fb3d30e982e541159a1ad102a22adfdad8d41d60e409fa9273961e606040c.jpeg",
    "https://cdn.faire.com/fastly/688aadf133b961bc7ec8aa63088bd5d69b8adda94a0a87ae5d0b8e7065e2537f.jpeg",
    "https://cdn.faire.com/fastly/6a7eaf13be02e2820cf3aebafd8e3bcd7881bd843330d6a548c77c3ddc8e2c72.jpeg",
    "https://cdn.faire.com/fastly/8a0bb5dc28d2fd7f1305e0489e3d8ee7d98418db3ece03db3a39a8cbec0e7449.jpeg",
    "https://cdn.faire.com/fastly/5f882a77a011968246f97729b6adf2504e9923a934f7999ce8f80f1c123bf6dd.jpeg",
    "https://cdn.faire.com/fastly/68385d151453c82cd474830f8fce4cfac82371ded38741ba173f6c515b8381ab.jpeg",
  ],
  priceDollars: 77,
  description:
    'NEW! Campo dei Fiori Travel Scarf/Wrap is a four-season go-to. Artfully composed of smooth modal eco-fiber and 15% sustainable wool. "It\'s a stroll in a Warholian garden!" Generously sized, this versatile travel piece can start the day as a scarf and become a wrap for evening — perfect for cocktails or gallery hopping. A smooth and cozy layer when you need it! Grab this versatile travel wrap/scarf before it disappears. Available in two vibrant color combinations: Garden Brights and Autumn Harvest. We are in love with this piece! \n•  Material: NEW, smooth 85 modal eco-fiber and 15 soft Italian wool\n•  Sustainable, organic, planet-friendly\n•  Size: generous 55 x 55 inches!\n• 100% Made in Italy',
  tags: [],
  msrpDollars: 154,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:43.309Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
